export default function trackLeadFormWithPasswordLoaded() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'LeadWithPasswordFormLoaded',
  });
}
